import React from "react";
import { ChevronRight, Check } from "lucide-react";
import { FavHeart } from "../../components/soulumoSignature/FavHeart";
import { displayName } from "./signatureWorlds";

export const TOK = {
  ink: "#0d1f3a",
  gold: "#d7bb7a",
  goldSoft: "#c8a45a",
  goldMist: "rgba(215,187,122,0.22)",
  cream: "#f5ecd9",
  creamDim: "rgba(245,236,217,0.72)",
  creamMist: "rgba(245,236,217,0.42)",
};

// Soulumo navy with a soft light from above — matches Home + the journey builder.
export const NAVY_BG = "radial-gradient(ellipse at 50% 0%, #1a3058 0%, #0d1f3a 45%, #091629 100%)";

export const SERIF = '"Cormorant Garamond", serif';
export const SANS = '"Manrope", sans-serif';

// Breathing orb — the same Soulumo orb, tinted per world.
export const Orb = ({ gradient, size = 120, className = "", style = {}, testId, blur = true }) => (
  <div
    aria-hidden
    data-testid={testId}
    className={`pointer-events-none rounded-full sig-orb-breathe ${className}`}
    style={{ width: size, height: size, background: gradient, filter: blur ? `blur(${Math.round(size / 12)}px)` : "none", ...style }}
  />
);

export const SectionLabel = ({ children, accent = TOK.goldSoft, testId }) => (
  <div className="flex items-baseline gap-3 mb-4" data-testid={testId}>
    <h2 className="text-[0.62rem] uppercase tracking-[0.32em]" style={{ color: accent, fontFamily: SANS }}>{children}</h2>
    <div className="flex-1 h-px" style={{ background: TOK.goldMist }} />
  </div>
);

// One quiet row: overline (optional) · name · tagline · duration · heart.
export const InstallRow = ({ bp, overline, accent = TOK.gold, onOpen, onFav }) => (
  <div className="flex items-center" style={{ borderBottom: `1px solid ${TOK.goldMist}` }}>
  <button
    type="button"
    onClick={onOpen}
    data-testid={`signature-row-${bp.id}`}
    className="sig-row flex-1 min-w-0 text-left py-4 flex items-center gap-4 transition-[opacity,transform] duration-200 active:scale-[0.995]"
    style={{ color: TOK.cream }}
  >
    <div className="flex-1 min-w-0">
      {overline && (
        <div className="text-[0.55rem] uppercase tracking-[0.28em] mb-1" style={{ color: accent, fontFamily: SANS }}>{overline}</div>
      )}
      <div className="text-[1.25rem] font-light leading-tight" style={{ fontFamily: SERIF }}>{displayName(bp)}</div>
      {bp.blurb && (
        <p className="mt-1 text-[0.85rem] italic leading-snug line-clamp-2" style={{ color: TOK.creamDim, fontFamily: SERIF }}>{bp.blurb}</p>
      )}
    </div>
    <div className="shrink-0 flex flex-col items-end gap-1.5">
      {bp.in_library ? <Check size={13} color={TOK.goldSoft} aria-label="In your library" /> : <ChevronRight size={14} color={TOK.creamMist} />}
      <span className="text-[0.6rem] tracking-[0.12em]" style={{ color: TOK.creamMist, fontFamily: SANS }}>
        {bp.overnight ? `${Math.round((bp.duration_minutes || 0) / 60)} h` : `${bp.duration_minutes} min`}
      </span>
    </div>
  </button>
  {onFav && <FavHeart key={`${bp.id}-${!!bp.favourite}`} bp={bp} onChange={onFav} size={16} />}
  </div>
);
